export class ScreenSize {
  static readonly XS = 480;
  static readonly SM = 640;
  static readonly MD = 768;
  static readonly LG = 1024;
  static readonly XL = 1280;
  static readonly XXL = 1536;
}
